module.exports = __webpack_public_path__ + "assets/img/555344f9e25d8f99de0ec1f707f9ae26.png";